import en from "@/i18n/en.json";
import nl from "@/i18n/nl.json";
import fr from "@/i18n/fr.json";
import de from "@/i18n/de.json";
import pl from "@/i18n/pl.json";
import ro from "@/i18n/ro.json";
import ar from "@/i18n/ar.json";
import zh from "@/i18n/zh.json";
import it from "@/i18n/it.json";

const TRANSLATIONS = { en, nl, fr, de, pl, ro, ar, zh, it };

export function useTranslation(lang) {
  const storedLang = typeof window !== 'undefined' && localStorage.getItem("pigeon-lang");
  const resolvedLang = storedLang || lang || "en";
  const t = (key) => {
    const dict = TRANSLATIONS[resolvedLang] || TRANSLATIONS.en;
    return dict[key] || TRANSLATIONS.en[key] || key;
  };
  return { t, lang: resolvedLang };
}

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "EN" },
  { code: "nl", label: "Nederlands", flag: "NL" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "pl", label: "Polski", flag: "PL" },
  { code: "ro", label: "Română", flag: "RO" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "zh", label: "中文", flag: "ZH" },
  { code: "ar", label: "العربية", flag: "AR" },
];

export default TRANSLATIONS;
